import React, { useState } from 'react';
import BulletinViewModal from './BulletinViewModal';
import { ImageUrl } from '../services/API';

const BulletinCard = ({ bulletin }) => {
  const { id, title, description, category, priority, imageUrl } = bulletin;
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Priority color mapping
  const priorityColors = {
    urgent: 'bg-red-600',
    high: 'bg-red-500',
    medium: 'bg-yellow-500',
    low: 'bg-green-500'
  };

  // Default image if none provided
  const defaultImage = 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop';
  // const displayImage = imageUrl?imageUrl : defaultImage;
  const displayImage = imageUrl
console.log("displayImage----",displayImage)
  const handleCardClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
// console.log("cover image----",imageUrl)
  return (
    <>
      <div 
       key={id}
        onClick={handleCardClick}
        className="group relative border-2 border-borderGray overflow-hidden rounded-xl shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105 cursor-pointer"
        style={{ backgroundColor: '#212C43' }}
      >
        {/* Image Container */}
        <div className="relative h-48 overflow-hidden">
          <img 
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300" 
            src={displayImage} 
            alt={title}
            // onError={(e) => {
            //   e.target.src = displayImage;
            // }}
          />
          {/* Overlay gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-60"></div>
          
          {/* Priority Badge */}
          {/* {priority && (
            <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold text-white ${priorityColors[priority.toLowerCase()] || 'bg-gray-500'}`}>
              {priority.toUpperCase()}
            </div>
          )} */}
          
          {/* Category Badge */}
          {category && (
            <div className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold text-white bg-blue-600/80 backdrop-blur-sm">
              {category}
            </div>
          )}
        </div>

        {/* Content Container */}
        <div className="p-5">
          {/* Title */}
          <h3 className="text-lg font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-300 transition-colors duration-200">
            {title}
          </h3>
          
          {/* Description */}
          <div className="text-gray-300 text-sm leading-relaxed mb-4 line-clamp-3">
            {description}
          </div>
          
          {/* Read More Indicator */}
          <div className="flex items-center justify-between">
            <span className="text-blue-400 text-sm font-medium group-hover:text-blue-300 transition-colors duration-200">
              Read More →
            </span>
            {/* <div className="w-8 h-0.5 bg-blue-400 group-hover:bg-blue-300 transition-colors duration-200"></div> */}
          </div>
        </div>

        {/* Hover Effect Border */}
        <div className="absolute inset-0 border-2 border-transparent group-hover:border-blue-400 rounded-lg transition-all duration-300 opacity-0 group-hover:opacity-100"></div>
      </div>
      
      {/* Modal */}
      <BulletinViewModal 
        bulletin={bulletin}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  );
};

export default BulletinCard;